import { Routes } from '@angular/router';
import { RechtSucheComponent } from './recht-suche/recht-suche.component';
import { RechtListComponent } from './recht-list/recht-list.component';
import { RechtDetailComponent } from './recht-detail/recht-detail.component';
import { canActivateAuthorization } from '../../security/authorization.guard';
import { PermissionResponse } from '../../core/base-api';
import { RechtRubrikService } from './recht-detail/recht-rubrik/recht-rubrik.service';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const RechtRoutes: Routes = [
  {
    path: 'recht',
    loadChildren: () => routes,
    providers: [RechtRubrikService]
  }
];

const routes: Routes = [
  {
    path: '',
    component: RechtSucheComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.STANDARDRECHT_REGISTER, PermissionsEnum.PFANDRECHT_REGISTER],
      breadcrumb: 'recht.search.breadcrumb',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list/:searchMode',
    component: RechtListComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.STANDARDRECHT_REGISTER, PermissionsEnum.PFANDRECHT_REGISTER],
      breadcrumb: 'shared.breadcrumb.list',
      breadcrumbStatus: 'secondLevel'
    }
  },
  {
    path: 'detail',
    component: RechtDetailComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [
        PermissionsEnum.ANZEIGE_DIENSTBARKEITEN,
        PermissionsEnum.ANZEIGE_GRUNDLASTEN,
        PermissionsEnum.ANZEIGE_VORMERKUNGEN,
        PermissionsEnum.ANZEIGE_ANMERKUNGEN,
        PermissionsEnum.ANZEIGE_PFANDRECHTE
      ]
    }
  }
];
